import { createContext, useContext } from "react";

export const LayoutRenderScaleContext = createContext<number>(1);

/**
 * Returns the current render scale used by LayoutRenderer.
 *
 * Components can use this to adapt pixel-based styles (e.g. fontSize)
 * so the editor preview matches the final full-resolution display.
 */
export function useLayoutRenderScale(): number {
  return useContext(LayoutRenderScaleContext);
}
